export const HOME = 'home'
